import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { fetchAuthSession } from 'aws-amplify/auth';
import { OwnedCacheService } from '../services/owned-cache.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private amplifyService: AuthenticatorService,
    private router: Router,
    private ownedCache: OwnedCacheService
  ) { }

  async canActivate(): Promise<boolean> {
    try {
      const session = await fetchAuthSession();

      if (!session.tokens?.idToken) {
        this.ownedCache.clearOwner();
        this.router.navigate(['/login'], { queryParamsHandling: 'merge' });
        return false;
      }

      // This guard runs before every protected route and has already paid for the
      // session, so it is the natural place to establish who owns the client caches.
      // Anything reading a cache after this point can attribute it to a verified
      // subject rather than to a bookkeeping key that can drift out of sync.
      this.ownedCache.setOwnerFromSession(session);

      return true;
    } catch (e) {
      this.ownedCache.clearOwner();
      this.router.navigate(['/login'], { queryParamsHandling: 'merge' });
      return false;
    }
  }
}